import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyOrders = lazy(() =>
  import(/* webpackChunkName: 'Orders' */ './index'),
);

export default function Orders(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyOrders {...props} />
    </Suspense>
  );
}
